export const UPDATE_SEARCHTDATA_TATTOANCHODUYET =
  "UPDATE_SEARCHTDATA_TATTOANCHODUYET";
